import React from 'react';
import { Route, Routes } from 'react-router-dom';

import useUser from 'hooks/useUser';
import UnauthorizedPage from 'components/layout/UnauthorizedPage';

import BedBoardPage from './BedBoardPage';

const BedBoardRoutes: React.FC = () => {
  const { appUser, hasBedEntry } = useUser();
  const canAccess = !!appUser?.burnCenterId && hasBedEntry;

  return (
    <Routes>
      <Route path="/" element={canAccess ? <BedBoardPage /> : <UnauthorizedPage />} />
    </Routes>
  );
};

export default BedBoardRoutes;
